import { BIBLES } from './bibles'

const MAX_BOOKS = 140
const books = new Map()

export const loadBook = (bible, book) => {
  const key = `${bible}/${book}`
  let promise = books.get(key)

  if (promise) {
    books.delete(key)
  }
  else {
    promise = fetch(`/data/${BIBLES[bible].code.toLowerCase()}/${book}.json`)
      .then(resp => {
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        return resp.json()
      })
      .catch(error => {
        books.delete(key)
        throw error
      })
  }

  books.set(key, promise)
  books.size > MAX_BOOKS && books.delete(books.keys().next().value)

  return promise
}
